import React, { useEffect, useState } from "react";
import axios from "axios";
import { FcPlus } from "react-icons/fc";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Button, Grid, Typography } from "@mui/material";
import { v4 as uuidv4 } from "uuid";

const CopyItemdetails = (props) => {
  let len = props.addMore.length - 1; //length
  // let len = 0;
  console.log(len,"lengthvalue");
  let testlen = props.addMore.length - 2;
  let descriptiv = "descriptive" + len; //get id for description
  let test = "test-" + testlen; //last nos test id
  let dstin = "distin-" + len;
  // console.log("ali",len);

  // console.log(test)
  // var party_code;
  // var party_code=document.getElementById("party_code")
  // if (party_code != null) {
  //   party_code = party_code.value;
  //   if(party_code!=null){
  //     // document.getElementById("distin").value=party_code;
  //   }
  // }

  //----------get Last Nos logics start--------
  const [notest, setnotest] = useState();
  const [lastValue, setlastValue] = useState(0);
  function testChange(e) {
    
    // var testNo=document.getElementById(test).value
    var verticletype = document.getElementById("verticle_type").value;
    var date = document.getElementById("date").value;
    var series = document.getElementById("serial_type").value;
    console.log("HELLO");
    console.log(verticletype);
    // console.log('kfk',testNo)
    if (len == 1) {
      var testNo = document.getElementById(test).value;
      var testNos = testNo;
      // setlastValue(testNos)
    } else {
      var testNos = 1;
      // setlastValue(testNos)
    }

    var name = e.target.name;
    var id = e.target.id;
    console.log(e.target,"target");
    var finalNoValue = "";
    if (name === "test") {
      var swlvalue = e.target.value;
      if (verticletype) {
        var lastNo = "";
        if (id == "test-0") {
          axios
            .get(`api/last_nos/${verticletype}/${date}/${series}`)
            .then((res) => {
              var lastNo = res.data.lastNos;
              var swvalue = Number(lastNo) + Number(swlvalue)-1;
              if(swvalue != 1){
                swvalue+=1;
              }
              else{
                swvalue=swvalue;
              }
              console.log(swlvalue, "ALI");
              setlastValue(swvalue + 1);
              var finalNoValue;
              if(lastNo == swvalue){
                 finalNoValue = swvalue;
              }
              else if(swlvalue==1){
                finalNoValue = swvalue;
              }
              else{
                finalNoValue = lastNo + " to " + swvalue;
              }
              console.log(swlvalue, "ALI2");
              setnotest(finalNoValue);
            });
        }
         else {
          console.log("ali",lastValue);
          var swvalue = Number(lastValue) + Number(swlvalue) - 1;
          var tens = Math.floor(swlvalue/10 % 10);
          console.log("tens place",tens);
          var myValue = lastValue-tens;
          var finalNoValue = myValue + " to " + swvalue;
          setlastValue(swvalue + 1);
          setnotest(finalNoValue);
        }
      }
    }
    setnotest(finalNoValue);
  }

  //----------get Last Nos logics end--------

  //
  const [distinc, setdistinc] = useState();
  useEffect(() => {
    var party_code = document.getElementById("party_code").value;
    var date = document.getElementById("date").value;
    // console.log(date);
    // var dateArray = '';
    var dateArray = date.split("-");
    var distinct = "";
    if (party_code) {
      if (date) {
        var distinct = party_code + "/ " + dateArray[2] + "/ ";
      } else {
        var distinct = party_code + "/ ";
      }
    }
    var finalTaxt = distinct + notest + finaldistinc;
    // setdistinc({...distinc,[dstin]:finalTaxt});
    setdistinc(distinct);
    // console.log(distinc)
  }, []);

  // swl and nos no continate and populate disy=ting value
  const [finalvalue, setfinalvalue] = useState([]);
  const [finaldistinc, setfinaldistinc] = useState();
  function swlChange(e) {
    var ids = e.target.id;
    // const splitString = ids.split(" ");
    // console.log(splitString[1],"splitString[2]");
    // var idvalue = e.target.data-id;
    // console.log(idvalue,"idvalue");
    // var dstin = "distin-" + idvalue;
    console.log(ids,"idsconsole");
    console.log(e,"econsole");
    var name = e.target.name;
    var finalSwlValue = "";
    var party_code = document.getElementById("party_code").value;
    var date = document.getElementById("date").value;
    var dateArray = date.split("-");
    var distinct = "";
    if (party_code) {
      if (date) {
        var distinct = party_code + "/ " + dateArray[1] + "/ ";
      } else {
        var distinct = party_code + "/ ";
      }
    }

    // if (name === "swltonns") {
      // var swlvalue = e.target.value;
      var swlvalue = document.getElementById(ids).value;
      
      var finalSwlValue = "\n SWL " + swlvalue;
    // }
    // setfinaldistinc(finalSwlValue)
    var finalTaxt = distinct + notest + finalSwlValue;
    // console.log(finaldistinc)
    

    setfinalvalue({ ...finalvalue, [ids]: finalTaxt });
    // console.log(ids,"fianl");
  
  }

  function swlChange2(e) {
    var name = e.target.name;
    var ids = e.target.id;
    const splitString = ids.split(" ");
    var dstin = "distin-" + splitString[2];
    var finalSwlValue = "";
    var party_code = document.getElementById("party_code").value;
    var date = document.getElementById("date").value;
    var dateArray = date.split("-");
    var distinct = "";
    if (party_code) {
      if (date) {
        var distinct = party_code + "/ " + dateArray[1] + "/ ";
      } else {
        var distinct = party_code + "/ ";
      }
    }

    // if (name === "swltonns") {
      // var swlvalue = e.target.value;
      var swlvalue = document.getElementById("swltonns2"+len).value;
      
      var finalSwlValue = "\n SWL " + swlvalue;
    // }
    // setfinaldistinc(finalSwlValue)
    var finalTaxt = distinct + notest + finalSwlValue;
    // console.log(finaldistinc)

    setfinalvalue({ ...finalvalue, [dstin]: finalTaxt });
  }
  {
    /*-------------------------- get catogeory value ----------------------------------------*/
  }
  const [categorylist, setCategorylist] = useState([]);
  useEffect(() => {
    axios.get(`api/show_categorydetails`).then((res) => {
      if (res.status === 200) {
        // console.log(res.data.categorydetails);
        setCategorylist(res.data.categorydetails);
      }
    });
  }, []);

  const values = categorylist.map((item) => {
    return (
      <option value={categorylist.categoryname}>{item.categoryname}</option>
    );
  });

  {
    /*-------------------------- get sub catogeory value ----------------------------------------*/
  }

  const [subCategory, setsubCategory] = useState([]);
  function handleCategory(event) {
    let categoryName = event.target.value;
    axios.get(`api/subcatgory_details/${categoryName}`).then((res) => {
      if (res.status === 200) {
        setsubCategory({
          ...subCategory,
          [event.target.id]: res.data.subCatgoryDetails,
        });
      }
    });
  }

  {
    /*-------------------------- get Item Name ----------------------------------------*/
  }
  const [items, setItem] = useState([]);
  function handleItem(event) {
    let subCategoryName = event.target.value;
    // var categoryname=document.getElementById("categoryname"+len).value
    // console.log(categoryname);

    axios.get(`api/item_details/${subCategoryName}`).then((res) => {
      if (res.status === 200) {
        setItem({ ...items, [event.target.id]: res.data.itemDetails });
      }
    });
  }

  {
    /*-------------------------- get Desiption value ----------------------------------------*/
  }
  let [description, setDescription] = useState([]);
  function handleDes(event) {
    let item = event.target.value;
    axios.get(`api/description/${item}`).then((res) => {
      if (res.status === 200) {
        let des = res.data.desctiption;
        // setDescription({...description,[event.target.id]:res.data.desctiption});
        document.getElementById(len).value = des;
      }
    });
  }

  {
    /*-------------------------- get Desiption length ----------------------------------------*/
  }

  const [lineCount, setlineCount] = useState([]);
  function descriptionLineCount(event) {
    let item = event.target.value;
    const descriptiveId = event.target.name + event.target.id;
    // console.log('getID',event.target.name+event.target.id);

    // let length = event.target.value.length;
    // if(length>70){
    //   var lineCheck = Math.floor(length/60)
    //   // console.log('Length',lineCheck)
    // }else{
    //   var lineCheck = 0;
    // }
    let count = 1; //+lineCheck;
    for (let i = count; i < event.target.value.length; i++) {
      if (event.target.value[i] == "\n") {
        count++;
      }
    }
    // let totalLineCount = lineCount + count;
    // console.log('Previous count',count);
    // setlineCount(count);
    setlineCount({ ...lineCount, [descriptiveId]: count });
  }
  // console.log('Linecount',lineCount);

  // remove line count
  function removecount(val, deletebutton) {
    props.delete(val);
    setlineCount((current) => {
      const copy = { ...current };
      delete copy[deletebutton];
      return copy;
      // remove cost key from object
      // const {cost, ...rest} = current;
      // return rest;
      // console.log(current)
    });
    // console.log('Delete index',Math.round(val.index))
  }

  {
    /*---------------------line count logics ----------------*/
  }
  var count = Object.keys(lineCount).length;

  var checklineCount = 0;

  for (let index = 0; index < count; index++) {
    if (len >= index) {
      let indexche = "descriptive" + index;
      // console.log('Index',indexche)
      if (indexche in lineCount) {
        checklineCount += lineCount[indexche];
        // console.log('checklineCount',checklineCount)
      }
    }
  }
  // const [totalLine, settotalLine] = useState([checklineCount]);

  // console.log('Total count',checklineCount)

  // props.delete()

  {
    /*-------------------------- Submit and add more button disabled after line count 16 -----------------------------------*/
  }
  if (checklineCount > 15) {
    alert("use max 15 lines ");
    // hide("#button")
    document.getElementById("submit").disabled = true;
    // document.getElementById("plusButton").disabled = true;
    // ("#button").remove();
  } else if (checklineCount < 15) {
    // document.getElementById("submit").disabled = false;
    const button = document.getElementById("submit");
    // console.log(button);
    // const buttonPlus = document.getElementById('plusButton').disabled=true;
    if (button != null) {
      button.disabled = false;
    }
  }

  return props.addMore.map((val, idx) => {
    // console.log(idx,"idxconsole");
    let distin = `distin-${idx}`,
      sn = `sn-${idx}`,
      descriptive = `descriptive-${idx}`,
      test = `test-${idx}`,
      pltonns = `pltonns-${idx}`,
      swltonns = `swltonns-${idx}`,
      categoryname = `categoryname${idx}`,
      item = `item${idx}`,
      subcategory = `subcategory${idx}`,
      nostest_remarks = `nostest_remarks${idx}`,
      swltonns2 = `swltonns2${idx}`,
      deletebutton = `descriptive${idx}`;
    // console.log(val.distin=1)
    return (
      <tr key={val.index}>
        <td>
          <select
            name="categoryname"
            style={{ marginTop: "2px" }}
            data-id={idx}
            id={categoryname}
            onChange={handleCategory}
            className="form-control"
          >
            <option value="">-Select Category-</option>
            {values}
          </select>
          <select
            name="subcategory"
            style={{ marginTop: "10px" }}
            data-id={idx}
            id={subcategory}
            onClick={handleItem}
            values={subCategory}
            className="form-control"
          >
            <option value="">-Select Sub Category-</option>
            {subCategory[categoryname]?.map((item) => {
              return <option>{item.subcategoryname}</option>;
            })}
          </select>
          <select
            name="item"
            style={{ marginTop: "10px" }}
            data-id={idx}
            id={item}
            onClick={handleDes}
            className="form-control"
          >
            <option value="">-Select Item Name-</option>
            {items[subcategory] != undefined
              ? items[subcategory].map((item) => {
                  return <option>{item.itemname}</option>;
                })
              : console.log()}
          </select>
        </td>

        <td>
          <textarea
            name="distin"
            defaultValue={(val.distin = finalvalue[swltonns])}
            rows="4"
            data-id={idx}
            id={distin}
            className="form-control"
          ></textarea>
        </td>
        {/*<td>
            <input type="text"  style={{paddingTop: "30px",paddingBottom: "30px",marginTop:"12px"}} height="100" name="sn" id={sn} data-id={idx} className="form-control " />
          </td>*/}

        <td>
          <textarea
            name="descriptive"
            cols="5"
            defaultValue={val.descriptive}
            onChange={descriptionLineCount}
            id={idx}
            data-id={idx}
            className="form-control"
            rows="8"
          ></textarea>
        </td>
        <td>
          <input
            type="text"
            onChange={testChange}
            style={{
              paddingTop: "30px",
              paddingBottom: "30px",
              marginTop: "12px",
            }}
            name="test"
            id={test}
            data-id={idx}
            className="form-control "
          />
          <input
            type="nostest_remarks"
            style={{
              paddingTop: "30px",
              paddingBottom: "30px",
              marginTop: "12px",
            }}
            name="nostest_remarks"
            id={nostest_remarks}
            data-id={idx}
            className="form-control "
          />
        </td>
        <td>
          <input
            type="text"
            style={{
              paddingTop: "30px",
              paddingBottom: "30px",
              marginTop: "12px",
            }}
            name="pltonns"
            id={pltonns}
            data-id={idx}
            className="form-control "
          />
        </td>
        <td>
          <textarea
            type="text"
            onChange={swlChange}
            rows="4"
            style={{ marginTop: "12px" }}
            name="swltonns"
            id={swltonns}
            data-id={idx}
            className="form-control "
          />
          <textarea
            type="text"
            rows="2"
            style={{ marginTop: "12px" }}
            name="swltonns2"
            id={swltonns2}
            data-id={idx}
            className="form-control "
          />
        </td>
        <td>
        {/* <input class="form-check-input" style={{ marginTop: "14px",marginLeft:"15px" }} onClick={swlChange} type="radio" name="flexRadioDefault" id="flexRadioDefault1" /> */}
        {/* <label class="form-check-label" for="flexRadioDefault1">
          Default radio
        </label> */}
        <input class="form-check-input" onClick={swlChange2} style={{ marginTop: "150px",marginLeft:"15px" }} type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
        {/* <label class="form-check-label" for="flexRadioDefault1">
          Default radio
        </label> */}
        </td>
        <td>
          {idx === 0 ? (
            checklineCount < 16 ? (
              <Button
                title="Add More"
                style={{
                  color: "white",
                  marginTop: "30px",
                  minWidth: "0px",
                  padding: "0px",
                }}
                onClick={() => props.add()}
                type="button"
              >
                <FcPlus />
              </Button>
            ) : (
              console.log("jjd")
            )
          ) : (
            <Button
              id={deletebutton}
              startIcon={<DeleteIcon color="inherit" />}
              style={{
                color: "#cc0000",
                marginTop: "30px",
                minWidth: "0px",
                padding: "0px",
              }}
              onClick={() => removecount(val, deletebutton)}
            ></Button>
          )}
        </td>
      </tr>
    );
  });
};
export default CopyItemdetails;
